import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'ecu-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css'],
})
export class ButtonComponent {
  @Input() class: string;
  @Input() color: ThemePalette = 'primary';

  @Input() isDisabled = false;
  @Input() isLoading = false;

  @Output() click = new EventEmitter<Event>();

  onClick(event: Event) {
    event.stopPropagation();
    if (!this.isLoading) {
      this.click.emit(event);
    }
  }
}
